<template>
  <div>
    <v-alert v-if="introText" type="info" dense class="mb-4">
      {{ introText }}
    </v-alert>
    <Register
      :create-mode="'emit'"
      :prefill-email="signatoryEmail"
      :min-adult-age="minAdultAge"
      @created="handleCreated"
      @previusStep="handleCancel"
    />
  </div>
</template>

<script>
import Register from "@/components/Riders/Register.vue";
import { VAlert } from "vuetify/lib";

export default {
  name: "SignatoryAccountStepper",
  components: {
    Register,
    VAlert
  },
  props: {
    signatoryEmail: {
      type: String,
      default: ""
    },
    introText: {
      type: String,
      default: ""
    },
    minAdultAge: {
      type: Number,
      default: 0
    }
  },
  methods: {
    handleCreated(payload) {
      this.$emit("created", payload);
    },
    handleCancel() {
      this.$emit("cancel");
    }
  }
};
</script>
